import { ReactNode } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const badgeVariants = cva("rounded-3xl inline-flex items-center justify-center", {
    variants: {
        variant: {
            "primary": "bg-softBlue text-primary300",
            "blue": "bg-primary200 text-primary400",
            "secondary": "bg-secondary300 text-trueBlack",
            "danger": "bg-[#F43E5C] text-pureWhite",
        },
        size: {
            "lg": "py-1 px-4 h-8",
            "md": "py-1 px-4 h-8",
            "sm": "py-1 px-2 h-6",
        },
    },
    defaultVariants: {
        variant: "primary",
        size: "lg",
    },
});

type Props = VariantProps<typeof badgeVariants> & {
    children?: ReactNode;
    className?: string;
}

export const Badge = ({ children, className, variant, size = "lg" }: Props) => {
    return (
        <div className={cn(badgeVariants({ className, variant, size }))}>{children}</div>
    );
};

export default Badge;
